import { useEffect } from 'react';

const useSeo = (title, description, image) => {
  useEffect(() => {
    // Title
    const prevTitle = document.title;
    if (title) {
      document.title = title;
    }

    // Meta tags
    const metaTags = [
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:type', content: 'article' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ];

    const createdTags = [];

    metaTags.forEach((tag) => {
      if (!tag.content) return;

      let element;
      if (tag.name) {
        element = document.querySelector(`meta[name="${tag.name}"]`);
      } else if (tag.property) {
        element = document.querySelector(`meta[property="${tag.property}"]`);
      }

      if (element) {
        // Store previous content to restore later (optional, usually not needed for SPA navigation)
        // element.setAttribute('content', tag.content);
        // For simplicity in SPA, we often just update it.
        // But to be cleaner, let's update.
        element.setAttribute('content', tag.content);
      } else {
        // Create new meta tag
        const newElement = document.createElement('meta');
        if (tag.name) newElement.setAttribute('name', tag.name);
        if (tag.property) newElement.setAttribute('property', tag.property);
        newElement.setAttribute('content', tag.content);
        document.head.appendChild(newElement);
        createdTags.push(newElement);
      }
    });

    return () => {
      // Cleanup: Restore title or remove created tags
      // In a real SPA, the next page's useSeo will overwrite these,
      // but cleaning up newly created ones is good practice.
      document.title = prevTitle;
      createdTags.forEach((tag) => {
        document.head.removeChild(tag);
      });
      // Note: We don't revert updated tags to avoid flickering or incorrect state if next page doesn't set them.
    };
  }, [title, description, image]);
};

export default useSeo;
